import { Box, Tooltip, Typography } from '@mui/material';
import { StyledTitleTableOrdering } from './OrderConfirmModal/styled';

export const renderTableNumberSection = (row) => {
  const tableNumber =
    row?.metadata?.tableDetails?.tableDetails?.name ||
    row?.orderMetaData?.tableNumber;
  const orderNumber = row?.number;
  const displayNumber = row?.displayNumber;

  if (!tableNumber) {
    return (
      <Box>
        <Typography>{`#${orderNumber}`}</Typography>
        {displayNumber ? (
          <Typography
            sx={{ fontWeight: 'bold' }}
          >{`#${displayNumber}`}</Typography>
        ) : (
          ''
        )}
      </Box>
    );
  }

  // Check if table number is too long (more than 16 characters)
  const isLongTableNumber = tableNumber?.length > 16;
  const isLongOrderNumber = orderNumber?.length > 12;
  const truncatedTableNumber = isLongTableNumber
    ? `${tableNumber.substring(0, 16)}...`
    : tableNumber;
  const truncatedOrderNumber = isLongOrderNumber
    ? `${orderNumber.substring(0, 12)}...`
    : orderNumber;

  if (isLongTableNumber) {
    // For long table numbers, stack them vertically
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '2px',
          maxWidth: '156px',
        }}
      >
        <Typography>{`#${truncatedOrderNumber}`}</Typography>
        <Tooltip title={`${tableNumber}`} placement="top">
          <Box sx={{ display: 'flex' }}>
            <Typography
              sx={{
                fontWeight: 'bold',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                cursor: 'pointer',
              }}
            >
              {truncatedTableNumber}
            </Typography>
            {displayNumber ? (
              <Typography
                sx={{ fontWeight: 'bold' }}
              >{`| #${displayNumber}`}</Typography>
            ) : (
              ''
            )}
          </Box>
        </Tooltip>
      </Box>
    );
  } else {
    // For short table numbers, keep them horizontal
    return (
      <Box
        sx={{
          display: 'flex',
          gap: '5px',
          maxWidth: '176px',
          flexDirection: 'column',
        }}
      >
        <Tooltip title={`${orderNumber}`} placement="top">
          <StyledTitleTableOrdering>{`#${orderNumber}`}</StyledTitleTableOrdering>
        </Tooltip>
        <Typography sx={{ fontWeight: 'bold' }}>{`${tableNumber} ${
          displayNumber ? `| #${displayNumber}` : ''
        }`}</Typography>
      </Box>
    );
  }
};
